import { trpc } from '@trashlab/api/src/library/frontend/utils/trpc';
import {
  invalidationPredicate,
  InvalidateArgs,
} from '@trashlab/api/src/library/server/fast-trpc/invalidation';

export const useTrpcInvalidate = () => {
  const context = trpc.useContext();

  return async (params: InvalidateArgs) => {
    await context.invalidate(undefined, {
      predicate: invalidationPredicate(params),
    });
  };
};
